export default "__VITE_ASSET__BckPgd0U__"